import {encode as base64_encode} from 'base-64';

export const generateDeviceFingerprint = () => {
  try {
    const navigatorInfo = window.navigator;
    const screenInfo = window.screen;

    const data = {
      userAgent: navigatorInfo.userAgent,
      language: navigatorInfo.language,
      platform: navigatorInfo.platform,
      screen: `${screenInfo.width}x${screenInfo.height}`,
      timezoneOffset: new Date().getTimezoneOffset(),
      storageSupport: {
        localStorage: typeof window.localStorage !== 'undefined',
        sessionStorage: typeof window.sessionStorage !== 'undefined',
      },
    };

    return base64_encode(JSON.stringify(data));
  } catch (error) {
    console.error('Erro ao gerar deviceFingerprint:', error);
    return null;
  }
};
